import React from 'react';
import { Box } from '@mui/material';
import {
  ViewDetailsAction,
  ViewInShopAction,
  AddToCartAction,
  TrackAction,
  MakeOfferAction,
  ShareAction,
} from './index';
import ToolsIcon from '../ToolsIcon';

export interface ItemActionsProps {
  item: {
    id: number;
    original_rarity?: string;
    d2rshopproductlink?: string;
    context?: string;
    status?: 'in_cart' | 'not_in_cart';
    is_product?: boolean;
  };
  sessionToken?: string | null;
  showViewDetails?: boolean;
  showViewInShop?: boolean;
  showAddToCart?: boolean;
  showTrack?: boolean;
  showMakeOffer?: boolean;
  showShare?: boolean;
  showToolsIcon?: boolean;
  size?: 'small' | 'medium' | 'large';
  onShare?: (url: string) => void;
  onTrackChange?: (tracked: boolean) => void;
  sx?: any;
}

export default function ItemActions({
  item,
  sessionToken,
  showViewDetails = true,
  showViewInShop = true,
  showAddToCart = true,
  showTrack = true,
  showMakeOffer = true,
  showShare = true,
  showToolsIcon = false,
  size = 'small',
  onShare,
  onTrackChange,
  sx = {},
}: ItemActionsProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: showToolsIcon ? '8px' : '4px',
        flex: 1,
        justifyContent: showToolsIcon ? 'space-between' : 'center',
        ...sx,
      }}
    >
      {/* Tools Icon */}
      {showToolsIcon && <ToolsIcon />}

      {/* Actions Container */}
      <Box
        sx={{
          display: 'flex',
          gap: '4px',
          flex: showToolsIcon ? 1 : 'none',
          justifyContent: 'center',
        }}
      >
        {/* View Details Action */}
        {showViewDetails && <ViewDetailsAction item={item} size={size} />}

        {/* View in Shop Action */}
        {showViewInShop && item.d2rshopproductlink && <ViewInShopAction item={item} size={size} />}

        {/* Add to Cart Action */}
        {showAddToCart && sessionToken && item.context !== 'all' && (
          <AddToCartAction item={item} sessionToken={sessionToken} size={size} />
        )}

        {/* Track Action */}
        {showTrack && (
          <TrackAction
            item={item}
            sessionToken={sessionToken || undefined}
            size={size}
            onTrackChange={onTrackChange}
          />
        )}

        {/* Make Offer Action */}
        {showMakeOffer && (
          <MakeOfferAction item={item} sessionToken={sessionToken || undefined} size={size} />
        )}

        {/* Share Action */}
        {showShare && <ShareAction item={item} size={size} onShare={onShare} />}
      </Box>

      {/* Spacer for centering when ToolsIcon is shown */}
      {showToolsIcon && <Box sx={{ width: '32px' }} />}
    </Box>
  );
}
